import { render, staticRenderFns } from "./CompanyAllBrandSelect_1.vue?vue&type=template&id=261b3606&scoped=true&"
import script from "./CompanyAllBrandSelect_1.vue?vue&type=script&lang=js&"
export * from "./CompanyAllBrandSelect_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b3606",
  null
  
)

export default component.exports